import styled from "styled-components";
import { MasonryBox } from "../../../../../common/others/masonry/views/desktop/styled.js";
import { BoxShadow, BoxShadowHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
export const MasonryCarouselWrapper = styled.div.withConfig({
    displayName: "styled__MasonryCarouselWrapper",
    componentId: "sc-3d5e43ce-0"
})`
	${MasonryBox} {
		padding: 0px;
		background-color: transparent;
		background-image: url(${({ $backgroundImage  })=>$backgroundImage});

		& div > a {
			${BoxShadow}
			transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 0.1);
		}
		& div > a:hover {
			${BoxShadowHover}
		}

		& .splide__list {
			padding-bottom: 4px !important;
		}
	}
`;

//# sourceMappingURL=styled.js.map